export default {
  icon: {
    margin: '0 5px 0 -5px'
  }
}
